import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  create_bucketlist_data_action,
  get_all_bucket_list_data_action,
  get_all_interview_kit_data_action,
  delete_interview_kit_by_id_data_action,
  send_bucket_by_email_data_action,
} from "../../../redux/_actions";
import { validateEmail } from "../../../_helpers/validators";
function useBucketListView(props) {
  const intitalFormData = {
    title: "",
    interview_kit_id: null,
  };
  const [loading, setLoading] = useState(false);
  const [loadingShare, setLoadingShare] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingCreateBucket, setLoadingCreateBucket] = useState(false);
  const [showAddBucketModal, setShowAddBucketModal] = useState(false);
  const [showShareBucketModal, setShowShareBucketModal] = useState(false);
  const [showDeleteBucketModal, setShowDeleteBucketModal] = useState(false);
  const [allBucketList, setAllBucketList] = useState([]);
  const [assessmentKits, setAssessmentKits] = useState();
  const [formData, setFormData] = useState();
  const [emailId, setEmailId] = useState("");
  const [sharingBucketlistId, setSharingBucketlistId] = useState(null);
  const [formError, setFormError] = useState();
  const [deleteBucketItemInfo, setDeleteBucketItemInfo] = useState(null);
  const [selectedKits, setSelectedKits] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { allInterviewKitsData } = useSelector(
    (state) => state.get_all_interview_kit_data_reducer
  );
  const { bucketListsData } = useSelector(
    (state) => state.get_all_bucket_list_data_reducer
  );

  const { createdBucketListData } = useSelector(
    (state) => state.create_bucketlist_data_reducer
  );

  useEffect(() => {
    getAssessmentKits();
    getAllBucketListApi();
    setFormData(intitalFormData);
  }, []);

  useEffect(() => {
    if (bucketListsData?.data) {
      setAllBucketList(bucketListsData?.data && bucketListsData?.data?.results);
    }
  }, [bucketListsData]);

  useEffect(() => {
    if (allInterviewKitsData?.data) {
      setAssessmentKits(allInterviewKitsData?.data);
    }
  }, [allInterviewKitsData]);

  useEffect(() => {
    if (createdBucketListData?.data) {
      setShowAddBucketModal(false);
      getAllBucketListApi();
      setFormData(intitalFormData);
      setSelectedKits([]);
    }
  }, [createdBucketListData]);

  const getAssessmentKits = async () => {
    setLoading(true);
    await dispatch(get_all_interview_kit_data_action());
    setLoading(false);
  };

  const getAllBucketListApi = async () => {
    setLoading(true);
    await dispatch(get_all_bucket_list_data_action());
    setLoading(false);
  };

  const onBlurHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setFormData({ ...formData, [name]: value });
  };
  const handleChange = (value) => {
    setSelectedKits(value);
  };

  const onCreateClick = async (e) => {
    setShowAddBucketModal(true);
  };

  const handleClose = async (e) => {
    setShowAddBucketModal(false);
  };

  const countTime = (data) => {
    let total_time = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        element?.questions &&
          element.questions.forEach((item) => {
            total_time = item?.time_to_answer + total_time;
          });
      });
    return total_time;
  };
  const onViewCandidatesClick = (interviewKit) => {
    navigate(`/submitted-candidates-assessments/${interviewKit}`);
  };

  const onSubmit = async () => {
    let errorData = {};
    if (formData?.title === "") {
      errorData.title = "Please Enter Title";
    }
    if (!selectedKits.length) {
      errorData.interview_kit_id = "Please Select Asessment Kit";
    }
    setFormError(errorData);

    if (!Object.keys(errorData).length) {
      const data = {
        bucket_list: "",
        title: formData.title,
        interview_kit_id: selectedKits,
        candidate: "",
      };
      setLoadingCreateBucket(true);
      const res = await dispatch(create_bucketlist_data_action(data));
      setLoadingCreateBucket(false);
    }
  };

  const handleDeleteBucketModal = (type, id, title) => {
    if (type) {
      setShowDeleteBucketModal(type);
      setDeleteBucketItemInfo({ id: id, title: title });
    } else {
      setShowDeleteBucketModal(type);
      setDeleteBucketItemInfo(null);
    }
  };

  const onDeleteBucketListHandler = async (id) => {
    if (id) {
      setLoadingDelete(true);
      const res = await dispatch(delete_interview_kit_by_id_data_action(id));
      getAllBucketListApi();
      setLoadingDelete(false);

      handleDeleteBucketModal(false);
    }
  };

  const onViewBucketListHandler = (id) => {
    navigate(`/view-bucket-list/${id}`, { state: { id: id } });
  };

  const shareBucketModalHandler = async (type, id) => {
    if (type) {
      setShowShareBucketModal(type);
      setSharingBucketlistId(id);
    } else {
      setShowShareBucketModal(type);
      setSharingBucketlistId(null);
      setEmailId("");
      setSelectedKits([]);
    }
  };

  const shareBucketListByEmail = async () => {
    let errorData = {};
    if (emailId === "") {
      errorData.emailId = "Please Enter Email Id";
    }
    if (!validateEmail(emailId)) {
      errorData.emailId = "Please Enter Valid Email Id";
    }

    setFormError(errorData);

    if (!Object.keys(errorData).length) {
      const data = {
        email: emailId,
        bucket_list: sharingBucketlistId,
      };
      setLoadingShare(true);
      const res = await dispatch(send_bucket_by_email_data_action(data));
      setLoadingShare(false);
      if (res.detail) shareBucketModalHandler(false);
    }
  };

  return {
    loading,
    loadingDelete,
    loadingShare,
    showAddBucketModal,
    loadingCreateBucket,
    allBucketList,
    assessmentKits,
    formError,
    showDeleteBucketModal,
    deleteBucketItemInfo,
    showShareBucketModal,
    emailId,
    handleChange,
    setEmailId,
    onBlurHandler,
    onCreateClick,
    handleClose,
    onSubmit,
    onViewBucketListHandler,
    onDeleteBucketListHandler,
    handleDeleteBucketModal,
    shareBucketModalHandler,
    shareBucketListByEmail,
  };
}
export default useBucketListView;
